/** @file DirectionGlyph: a small top-down picture of a puppet's drawn directions (1, 2, 4, 8 or 16 spokes). */
import type { ReactElement } from 'react';

const C = 12;
const R = 9;

/** Degrees clockwise from south (toward the viewer) of each spoke; two directions face east and west (a side view). */
const anglesOf = (n: number): number[] => Array.from({ length: n }, (_, i) => (n === 2 ? 90 : 0) + (360 / n) * i);

/** A 24 px ring with one spoke per direction; the first (the front, or east for two) is drawn in the accent colour. */
export function DirectionGlyph({ n }: { n: number }): ReactElement {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx={C} cy={C} r={R} fill="none" stroke="currentColor" strokeOpacity={0.35} />
      {anglesOf(n).map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        return (
          <line key={deg} x1={C} y1={C} x2={C - R * Math.sin(rad)} y2={C + R * Math.cos(rad)}
            stroke={i === 0 ? 'var(--p3-accent)' : 'currentColor'} strokeWidth={n >= 16 ? 1 : 1.5} strokeLinecap="round" />
        );
      })}
      <circle cx={C} cy={C} r={1.5} fill="currentColor" />
    </svg>
  );
}
